// Splits savings between the home currency and two foreign ones. Each currency earns its own rate over the term,
// and the scenario sets how far the home currency falls by the end of it.

function start() {
    const app = document.getElementById('currency-allocation-app');
    if (!app) {
        return;
    }

    const amountInput = document.getElementById('ca-amount');
    const scenarioInput = document.getElementById('ca-scenario');
    const yearsInput = document.getElementById('ca-years');
    const homeRateInput = document.getElementById('ca-rate-home');
    const foreignInputs = Array.from(app.querySelectorAll('[data-foreign]'));
    const foreignRates = Array.from(app.querySelectorAll('[data-foreign-rate]'));
    const number = new Intl.NumberFormat(app.dataset.culture, { maximumFractionDigits: 0 });
    const decimal = new Intl.NumberFormat(app.dataset.culture, { maximumFractionDigits: 1 });
    const home = app.dataset.home;
    const money = (value, code) => `${number.format(value)} ${code}`;
    const positive = input => Math.max(parseFloat(input.value) || 0, 0);
    const setText = (element, text) => {
        if (element) {
            element.textContent = text;
        }
    };

    function setBar(name, value, total) {
        const bar = app.querySelector(`[data-bar="${name}"]`);
        if (bar) {
            bar.style.width = `${total > 0 ? (value / total) * 100 : 0}%`;
            bar.style.display = value > 0 ? 'block' : 'none';
        }
    }

    function render() {
        const amount = positive(amountInput);
        const fall = Math.min(positive(scenarioInput), 60) / 100;
        const years = Math.min(Math.max(Math.round(positive(yearsInput)), 1), 30);
        const homeGrowth = Math.pow(1 + positive(homeRateInput) / 100, years);
        const shares = foreignInputs.map(positive);
        const homeShare = 100 - shares.reduce((sum, share) => sum + share, 0);

        const homeNow = amount * homeShare / 100;
        const homeLater = homeNow * homeGrowth;
        const foreignNow = shares.map(share => amount * share / 100);
        const foreignGrowth = foreignRates.map(input => Math.pow(1 + positive(input) / 100, years));
        const foreignLater = foreignNow.map((value, i) => value * foreignGrowth[i] / (1 - fall));
        const total = homeLater + foreignLater.reduce((sum, value) => sum + value, 0);
        const homeOnly = amount * homeGrowth;
        const scale = Math.max(amount, total, homeOnly);

        setText(document.getElementById('ca-home-share'), `${homeShare}%`);
        setText(document.getElementById('ca-home-amount'), number.format(homeNow));
        setText(document.getElementById('ca-scenario-display'), `${Math.round(fall * 100)}%`);

        foreignInputs.forEach((input, i) => {
            const rate = parseFloat(input.dataset.rate) || 0;
            setText(app.querySelector(`[data-foreign-display="${i}"]`), `${shares[i]}%`);
            setText(app.querySelector(`[data-row-share="${i}"]`), `${shares[i]}%`);
            setText(app.querySelector(`[data-row-amount="${i}"]`), number.format(foreignNow[i]));
            setText(app.querySelector(`[data-row-units="${i}"]`), rate > 0 ? money(foreignNow[i] / rate, input.dataset.code) : '—');
            setBar(`now-${i}`, foreignNow[i], scale);
            setBar(`after-${i}`, foreignLater[i], scale);
        });

        setBar('now-home', homeNow, scale);
        setBar('after-home', homeLater, scale);
        setBar('only-home', homeOnly, scale);
        setText(app.querySelector('[data-bar-total="now"]'), money(amount, home));
        setText(app.querySelector('[data-bar-total="after"]'), money(total, home));
        setText(app.querySelector('[data-bar-total="only"]'), money(homeOnly, home));

        const difference = total - homeOnly;
        const template = difference >= 0 ? app.dataset.summaryMore : app.dataset.summaryLess;
        setText(document.getElementById('ca-summary'), template
            .replace('{after}', money(total, home))
            .replace('{gain}', money(Math.abs(difference), home)));

        // the fall at which a foreign currency earns exactly as much as staying in the home one
        const parts = foreignInputs.map((input, i) => {
            const breakEven = Math.max(0, 1 - foreignGrowth[i] / homeGrowth) * 100;
            return `${input.dataset.code} ${decimal.format(breakEven)}%`;
        });
        setText(document.getElementById('ca-breakeven'), app.dataset.breakeven.replace('{list}', parts.join(', ')));
    }

    // the home currency takes what is left, so a slider stops where the shares would pass 100%
    foreignInputs.forEach((input, i) => {
        input.addEventListener('input', () => {
            const other = foreignInputs.reduce((sum, item, j) => (j === i ? sum : sum + positive(item)), 0);
            if (positive(input) + other > 100) {
                input.value = 100 - other;
            }
            render();
        });
    });
    [amountInput, scenarioInput, yearsInput, homeRateInput, ...foreignRates].forEach(input => input.addEventListener('input', render));
    render();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
} else {
    start();
}
